<p-confirmDialog [style]="{ width: 'min(100%, 28rem)' }" [breakpoints]="{ '640px': '95vw' }" />

<p-dialog
  [header]="duplicadoTitulo()"
  [visible]="duplicadoVisible()"
  (visibleChange)="duplicadoVisible.set($event)"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: 'min(100%, 28rem)' }"
>
  <p class="m-0 line-height-3">{{ duplicadoMensaje() }}</p>
  <div class="flex justify-content-end pt-3">
    <p-button type="button" label="Entendido" (onClick)="cerrarDuplicado()" />
  </div>
</p-dialog>

<form class="flex flex-column gap-4" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 class="text-xl font-semibold text-color m-0">Datos personales importantes</h2>

  <div class="grid">
    <div class="col-12 md:col-6 flex flex-column gap-1">
      <label class="text-sm font-semibold text-color" for="persona-nombre">
        Nombre <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <input
        pInputText
        id="persona-nombre"
        formControlName="nombre"
        placeholder="Ej: Carlos"
        autocomplete="given-name"
        class="w-full agregar-persona-step__underline agregar-persona-nombre"
        (blur)="onNombreBlur()"
        [class.ng-invalid]="showFieldError('nombre')"
        [class.ng-dirty]="form.controls.nombre.touched"
      />
      @if (showFieldError('nombre')) {
        <small class="text-red-500 text-xs">El nombre es obligatorio.</small>
      }
    </div>

    <div class="col-12 md:col-6 flex flex-column gap-1">
      <label class="text-sm font-semibold text-color" for="persona-apellido">
        Apellido <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <input
        pInputText
        id="persona-apellido"
        formControlName="apellido"
        placeholder="Ej: Navarro"
        autocomplete="family-name"
        class="w-full agregar-persona-step__underline agregar-persona-nombre"
        (blur)="onApellidoBlur()"
        [class.ng-invalid]="showFieldError('apellido')"
        [class.ng-dirty]="form.controls.apellido.touched"
      />
      @if (showFieldError('apellido')) {
        <small class="text-red-500 text-xs">El apellido es obligatorio.</small>
      }
    </div>

    <div class="col-12 md:col-6 flex flex-column gap-1">
      @if (segundoNombreEnabled()) {
        <label class="text-sm font-semibold text-color" for="persona-nombre2">Segundo nombre</label>
        <input
          pInputText
          id="persona-nombre2"
          formControlName="nombre2"
          placeholder="Ej: Andrés"
          autocomplete="additional-name"
          class="w-full agregar-persona-step__underline agregar-persona-nombre"
        />
      } @else {
        <div class="flex align-items-center gap-2 min-h-full">
          <p-checkbox
            inputId="persona-segundo-nombre"
            [binary]="true"
            [ngModel]="false"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="onSegundoNombreChange($event)"
          />
          <label class="text-sm font-semibold text-color m-0 cursor-pointer" for="persona-segundo-nombre">
            Habilitar segundo nombre
          </label>
        </div>
      }
    </div>

    <div class="col-12 md:col-6 flex flex-column gap-1">
      <div class="flex gap-2 align-items-end">
        <div class="flex flex-column gap-1 w-6rem md:w-7rem flex-shrink-0">
          <label class="text-sm font-semibold text-color" for="persona-prefijo">Pre fijo</label>
          <p-select
            inputId="persona-prefijo"
            formControlName="prefijo"
            [options]="prefijos"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full agregar-persona-step__underline-select"
          />
        </div>

        <div class="flex flex-column gap-1 flex-1 min-w-0">
          <label class="text-sm font-semibold text-color" for="persona-celular">Celular</label>
          <input
            pInputText
            id="persona-celular"
            formControlName="celular"
            placeholder="Ej: 1122334455"
            inputmode="tel"
            autocomplete="tel-national"
            class="w-full agregar-persona-step__underline"
          />
        </div>
      </div>
    </div>

    <div class="col-12 md:col-4 md:col-offset-4 flex flex-column align-items-center gap-1">
      <label class="text-sm font-semibold text-color text-center" for="persona-nacimiento">
        Fecha de nacimiento <span class="text-red-500" aria-hidden="true">*</span>
      </label>
      <app-mayorap-datepicker
        inputId="persona-nacimiento"
        formControlName="nacimiento"
        [maxToday]="true"
        [invalid]="showFieldError('nacimiento')"
      />
      @if (showFieldError('nacimiento')) {
        <small class="text-red-500 text-xs">La fecha de nacimiento es obligatoria.</small>
      }
    </div>

    <div class="col-12 flex flex-column align-items-center gap-2">
      <span class="text-sm font-semibold text-color uppercase">Sexo</span>
      <div class="flex align-items-center gap-4">
        @for (option of sexoOptions; track option.value) {
          <div class="flex align-items-center gap-2">
            <p-radiobutton
              [inputId]="'persona-sexo-' + option.value"
              formControlName="sexo"
              [value]="option.value"
            />
            <label
              class="text-sm font-semibold text-color uppercase m-0 cursor-pointer"
              [for]="'persona-sexo-' + option.value"
            >
              {{ option.label }}
            </label>
          </div>
        }
      </div>
    </div>
  </div>

  <p-button type="submit" label="Siguiente" styleClass="w-full uppercase" [disabled]="form.invalid" />
</form>
